import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { getErrorLocale } from 'lib/i18n';

const FormError = ({ value, valid, error }) => {
  if (!value || !error || valid) return <></>;

  return (
    <div className="invalid-feedback">
      {ReactHtmlParser(getErrorLocale(error).defaultMessage)}
    </div>
  );
};

export default FormError;
